export default {
    getReadWidget: () => '<in-date-column field="::field" value="::value()"></in-date-column>',
    getLinkWidget: () => '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>',
    getFilterWidget: () => '<ma-date-field field="::field" value="value"></ma-date-field>',
    getWriteWidget: () =>
        '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>'
};



// WEBPACK FOOTER //
// ./app/components/common/crud/fieldView/DateTimeFieldView.js